import type { WorkspaceResource } from '@/hooks/useWorkspaceResourceAccess';
import type { ResourceActivityResourceType } from '@/types';

const workspaceResourceTypes: WorkspaceResource[] = [
    'dashboards',
    'folders',
    'investments',
    'lifecycles',
    'lists',
    'memos',
    'pipelines',
];

export const isCommentableWorkspaceResource = (
    resourceType: ResourceActivityResourceType,
): resourceType is WorkspaceResource => workspaceResourceTypes.includes(resourceType as WorkspaceResource);
